import { connect } from 'react-redux';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button, Form, Link } from 'react-bootstrap';
import moment from 'moment';

import * as upsellActions from '../../upsell/actions';
import { submission as utilSubmission } from '../../utils';
import QuoteBlock from '../../routes/FormResults/QuoteBlock';
import { Loading } from '../../components/shared';

const UPSELL_PRODUCTS = ['oi', 'ocp'];

class Upsell extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isBusy: false,
            relatedSubmissions: [],
            upsellProduct: null
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        const { submission } = this.props;
        const { type: product, relatedEntities } = submission;

        const upsellProduct = UPSELL_PRODUCTS.filter(
            type => type.toLowerCase() !== product.toLowerCase()
        ).shift();
        this.setState({
            upsellProduct
        });

        let props = utilSubmission.getRatingProperties(this.props.submission);
        Object.assign(props, {
            type: upsellProduct
        });

        if (relatedEntities && relatedEntities.submissions && relatedEntities.submissions.length) {
            const relatedSubmissions = relatedEntities.submissions.filter(
                submission => submission.type && submission.type.toLowerCase() === upsellProduct
            );
            this.setState({
                relatedSubmissions
            });
        } else {
            this.props.fetchUpsell(props);
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        this.props.onSubmit(this.state.relatedSubmissions);
    }

    render() {
        const { relatedSubmissions, upsellProduct } = this.state;

        // no upsell for already linked submissions
        if (relatedSubmissions.length) {
            return null;
        }

        const { upsell = {} } = this.props;
        const submission = this.props.submission;
        let theme = 'prominent';
        let mainTitle = null;
        let buttonProps = {
            disabled: this.state.isBusy || !this.props.isActiveBrokerage
        };
        let buttonLabel = `Apply for ${String(upsellProduct).toUpperCase()}`;
        buttonProps.bsStyle = 'default';

        switch (upsellProduct) {
            case 'oi':
                mainTitle = "Here is what you would pay with an Owner's Interest Policy:";
                break;
            case 'ocp':
                mainTitle = "Get a quote for Owner's and Contractors Protective";
                break;
            default:
        }

        const [upsellRating] = upsell.items;

        let rating = {};
        if (upsellRating) {
            rating = upsellRating['options'];
            rating.type = upsellProduct;
            let validateCreatedDate = moment(moment(submission.dateOfCreation).format('YYYY-MM-DD')).isAfter('2020-05-02');
            let validateEffDate = moment(moment(submission.anticipatedStartDate).format('YYYY-MM-DD')).isAfter('2020-05-02');
            if(validateEffDate && validateCreatedDate){
                rating.identityRecoveryPremium = 0;
            }
        }

        return (
            <div className="row">
                <div className="col-xs-8 mt">
                {upsell.isBusy ?
                   <Loading classes={['submitted']} width="5%" /> :
                   <div className={classNames('upsell-component', theme)}>
                       <div className="card card-primary center">
                           <section className="pb-x2 pl-x2 pr-x2">
                               <QuoteBlock
                                   key={`quote-block-1`}
                                   mainTitle={mainTitle}
                                   className={classNames('upsell', upsellProduct)}
                                   ratings={rating}
                               />
                               <Form onSubmit={this.handleSubmit}>
                                   <Button
                                       type="submit"
                                       id="upsellSubmitButton"
                                       {...buttonProps}
                                       className="mt"
                                   >
                                       {buttonLabel}
                                   </Button>
                               </Form>
                           </section>
                       </div>
                   </div>
                }
                </div>
            </div>
        );
    }
}

Upsell.propTypes = {
    submission: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    fetchUpsell: PropTypes.func.isRequired,
};

export default connect(
    store => {
        return {
            upsell: store.upsell
        };
    },
    {
        fetchUpsell: upsellActions.fetch,
    }
)(Upsell);
